import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import AnalyticsTracker from "./components/AnalyticsTracker";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import PostEditor from "./pages/PostEditor";
import PageEditor from "./pages/PageEditor";
import ContentPage from "./pages/ContentPage";
import ContactPage from "./pages/ContactPage";
import PetitionPage from "./pages/PetitionPage";
import CitizenActionPage from "./pages/CitizenActionPage";
import LawsuitDocumentsPage from "./pages/LawsuitDocumentsPage";
import SpotlightSeriesPage from "./pages/SpotlightSeriesPage";
import { AllNewsPage, PressReleasePage, InTheNewsPage } from "./pages/NewsPage";
import BlogPage from "./pages/BlogPage";
import ElectionJudgePage from "./pages/ElectionJudgePage";
import BoardOfElectionsDirectoryPage from "./pages/BoardOfElectionsDirectoryPage";
import CanvassWatchersToolkitPage from "./pages/CanvassWatchersToolkitPage";
import DataSourceStatementPage from "./pages/DataSourceStatementPage";

import DonatePage from "./pages/DonatePage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename={process.env.REACT_APP_PREVIEW_BASE || "/"}>
        {process.env.REACT_APP_PREVIEW_MODE !== "true" && <AnalyticsTracker />}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/post" element={<PostEditor />} />
          <Route path="/admin/page" element={<PageEditor />} />
          <Route path="/donate" element={<DonatePage />} />
          <Route path="/contact-us" element={<ContactPage />} />
          <Route path="/sign-the-petition" element={<PetitionPage />} />
          <Route path="/citizen-action" element={<CitizenActionPage />} />
          <Route path="/news" element={<AllNewsPage />} />
          <Route path="/press-release" element={<PressReleasePage />} />
          <Route path="/in-the-news" element={<InTheNewsPage />} />
          <Route path="/spotlight-series" element={<SpotlightSeriesPage />} />
          <Route path="/be-an-election-judge" element={<ElectionJudgePage />} />
          <Route path="/board-of-elections-directory" element={<BoardOfElectionsDirectoryPage />} />
          <Route path="/canvass-watchers-toolkit" element={<CanvassWatchersToolkitPage />} />
          <Route path="/data-source-statement" element={<DataSourceStatementPage />} />
          <Route path="/litigation-documents" element={<LawsuitDocumentsPage />} />
          <Route path="/lawsuit-document" element={<LawsuitDocumentsPage />} />
          <Route path="/articles" element={<AllNewsPage />} />
          <Route path="/blog/:slug" element={<BlogPage />} />
          {/* WordPress-style blog URLs — preserve existing links */}
          <Route path="/:year/:month/:day/:slug" element={<BlogPage />} />
          {/* Internal content pages — catch-all */}
          <Route path="/:slug" element={<ContentPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
